import * as React from 'react';
import { Textarea } from '@kajabi/sage-react';

import useEditResultItem from 'common/components/CopyMagic/hooks/useResultEditItem';
import { headlineAssistantSchema } from 'common/components/CopyMagic/shared/validationSchema';

const attributePath = ['headlineContent', 'headline'];
const HeadlineInput = () => {
  const { inputName, onChangeHandler, onBlurHandler, value, errorMessage } = useEditResultItem({
    attributePath,
    validationSchema: headlineAssistantSchema,
  });

  return (
    <Textarea
      name={inputName}
      id={inputName}
      data-testid={inputName}
      onChange={onChangeHandler}
      onBlur={onBlurHandler}
      value={value}
      message={errorMessage}
      hasError={!!errorMessage.length}
      rows={4}
    />
  );
};

export default HeadlineInput;
